/* eslint-disable react/prop-types */ // TODO: add props

export const QuestionInstructions = ({ question }) => (
  <div className="instructions">
    <span
      dangerouslySetInnerHTML={{
        __html: question.get('full_instructions_list').join(''),
      }}
    />
  </div>
);
